export default __webpack_public_path__ + "static/media/carnival1.14fc353a.jpeg";